import { useState } from "react";
import { Link } from "react-router-dom";

function Navbar({ user }) {
  const [open, setOpen] = useState(false);

  const desktopLinks = [
    { to: "/", label: "Home" },
    ...(!user ? [{ to: "/login", label: "Login" }] : []),
  ];

  const mobileLinks = [
    { to: "/", label: "Home" },
    ...(!user ? [{ to: "/login", label: "Login" }] : []),
    { to: "/profile", label: "Profile" },
  ];

  return (
    <nav className="bg-[#0d0d0f] border-b border-white/5 [font-family:'Syne',sans-serif]">
      <div className="max-w-7xl mx-auto px-6 py-3.5 flex justify-between items-center">

        {/* Logo */}
        <Link to="/" className="flex items-center gap-1.5 no-underline">
          <span className="text-white text-base font-semibold tracking-wide">GameGear</span>
          <span className="w-1.5 h-1.5 rounded-full bg-[#6f5bff] mb-0.5 inline-block" />
        </Link>

        {/* Desktop links */}
        <div className="hidden md:flex items-center gap-7">
          {desktopLinks.map(({ to, label }) => (
            <Link
              key={to}
              to={to}
              className="relative text-[0.78rem] font-medium tracking-wide text-gray-500 hover:text-white transition-colors duration-200 no-underline
                after:absolute after:bottom-[-2px] after:left-0 after:h-[1px] after:w-0 after:bg-[#6f5bff] after:transition-all after:duration-200
                hover:after:w-full"
            >
              {label}
            </Link>
          ))}

          {/* Profile */}
          <Link
            to="/profile"
            className="w-8 h-8 rounded-full bg-[#1e1b35] border border-[#6f5bff]/30 hover:border-[#6f5bff]/70
              flex items-center justify-center transition-all duration-200 no-underline group"
          >
            {user ? (
              <span className="text-[0.65rem] font-semibold text-[#8b7dff]">
                {user.email[0].toUpperCase()}
              </span>
            ) : (
              <svg className="w-4 h-4 text-gray-400 group-hover:text-[#8b7dff] transition-colors duration-200" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
                <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 6a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0zM4.501 20.118a7.5 7.5 0 0114.998 0A17.933 17.933 0 0112 21.75c-2.676 0-5.216-.584-7.499-1.632z" />
              </svg>
            )}
          </Link>

          <Link
            to="/cart"
            className="text-[0.75rem] font-semibold tracking-wide text-white bg-[#6f5bff] hover:bg-[#8472ff] px-3.5 py-1.5 rounded-md transition-colors duration-200 no-underline"
          >
            Cart
          </Link>
        </div>

        {/* Mobile: profile + cart + hamburger */}
        <div className="flex md:hidden items-center gap-3">
          <Link
            to="/profile"
            className="w-7 h-7 rounded-full bg-[#1e1b35] border border-[#6f5bff]/30
              flex items-center justify-center no-underline"
          >
            {user ? (
              <span className="text-[0.6rem] font-semibold text-[#8b7dff]">
                {user.email[0].toUpperCase()}
              </span>
            ) : (
              <svg className="w-3.5 h-3.5 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
                <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 6a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0zM4.501 20.118a7.5 7.5 0 0114.998 0A17.933 17.933 0 0112 21.75c-2.676 0-5.216-.584-7.499-1.632z" />
              </svg>
            )}
          </Link>
          <Link
            to="/cart"
            className="text-[0.75rem] font-semibold text-white bg-[#6f5bff] hover:bg-[#8472ff] px-3 py-1.5 rounded-md transition-colors duration-200 no-underline"
          >
            Cart
          </Link>
          <button
            onClick={() => setOpen(!open)}
            className="flex flex-col justify-center items-center w-8 h-8 gap-1.5 focus:outline-none"
            aria-label="Toggle menu"
          >
            <span className={`block h-[1.5px] bg-gray-400 transition-all duration-300 origin-center ${open ? "w-5 rotate-45 translate-y-[5px]" : "w-5"}`} />
            <span className={`block h-[1.5px] bg-gray-400 transition-all duration-300 ${open ? "w-0 opacity-0" : "w-4"}`} />
            <span className={`block h-[1.5px] bg-gray-400 transition-all duration-300 origin-center ${open ? "w-5 -rotate-45 -translate-y-[5px]" : "w-5"}`} />
          </button>
        </div>

      </div>

      {/* Mobile dropdown */}
      <div className={`md:hidden overflow-hidden transition-all duration-300 ease-in-out ${open ? "max-h-40 opacity-100" : "max-h-0 opacity-0"}`}>
        <div className="px-6 pb-4 pt-2 flex flex-col gap-4 border-t border-white/5">
          {mobileLinks.map(({ to, label }) => (
            <Link
              key={to}
              to={to}
              onClick={() => setOpen(false)}
              className="text-sm font-medium text-gray-400 hover:text-white transition-colors duration-200 no-underline"
            >
              {label}
            </Link>
          ))}
        </div>
      </div>
    </nav>
  );
}

export default Navbar;